module.exports = __webpack_public_path__ + "img/Logo-Fachverband_Fliesen_und_Naturstein.59b9e3db.jpg";